<template lang="pug">
  .grid
    .column.is-desktop-8.is-widescreen-6
      Content.is-normal.is-help
        div(v-html="question.body")
    .column.is-desktop-4
      .help-question.u-mb-xs(v-for="q in questions")
        AppLink.h6.u-mb-0.help-question-url(:to="`/knowledgebase/${$route.params.category}/${q.node.slug}`")
          AppIcon(name="arrowR2")
          span {{ q.node.title }}
</template>

<style lang="stylus">
.help-question
  &-url
    display: flex
    align-items: center
    margin: 0 -10px

  .icon
    margin: 0 10px

  span
    margin: 0 10px
    display: block
    flex: 1 0 0
</style>

<script>
import { Faq, Faqs } from '~/graphql/Faq.gql';
import Content from '~/components/Content';

export default {
  components: {
    Content
  },
  async asyncData({ params, app, error }) {
    try {
      const [faq, faqs] = await Promise.all([
        app.$api.query({
          query: Faq,
          variables: {
            slug: params.slug
          }
        }),
        app.$api.query({
          query: Faqs,
          variables: {
            category: params.category
          }
        })
      ]);

      if (!faq.data.faq) {
        error({
          statusCode: 404,
          message: 'Question not found'
        });
      }

      return {
        question: faq.data.faq,
        questions: faqs.data.faqs.edges.filter(faq => faq.node.slug !== params.slug)
      };
    } catch (err) {
      console.error(err);
      error({
        statusCode: 500,
        message: err.message
      });
    }
  },
  methods: {
    urlGenerate(str) {
      str = str.replace(/\s+/g, '-').toLowerCase();
      return str;
    }
  }
};
</script>
